import DataAdapter from 'rise-ui/adapters/apis/rise-api/data.js';

export default class ModelRun extends DataAdapter {}
